import {getReasonPhrase} from "http-status-codes";

export class ApiError extends Error {

    constructor(
        message: string,
        error: any,
    ) {
        let reason: string | undefined
        if (error.name === "TimeoutError") {
            message = message + " (Request timed out)"
        } else {
            const status = error?.response?.status || 500;
            if (status === 503 || status === 502) {
                message = "Service Unavailable, Please try again later"
            }
            if (typeof status === "number") {
                reason = getReasonPhrase(status);
            }
        }
        super(`${message}`);
        this.name = "ApiError";
    }

    toString() {
        return this.message;
    }

}